<template>
  <div>
    <headNavBar title="安全中心" />

    <van-field
      label="原密码"
      type="password"
      placeholder="请输入原密码"
      style="font-size:0.4rem"
      v-model="password.OldPassword"
    />
    <van-field
      label="新密码"
      type="password"
      placeholder="请输入新密码"
      style="font-size:0.4rem"
      v-model="password.NewPassword"
    />
    <van-field
      label="再次输入"
      type="password"
      placeholder="请再次输入新密码"
      style="font-size:0.4rem"
      v-model="password.AgainPassword"
    />
    <van-button
      type="info"
      size="large"
      style="margin:0.5rem 3%;font-size:0.5rem;width:94%;"
      @click="changePassword"
      :loading="ButtonLoading"
      >确认修改</van-button
    >
  </div>
</template>

<script>
import { Field, Button, Notify } from "vant";
import { SetChangePassword, SetUserChangePassword } from "@/api/my.js";
import { mapState } from "vuex";
import md5 from "js-md5";
export default {
  data() {
    return {
      password: {
        OldPassword: "",
        NewPassword: "",
        AgainPassword: "",
      },
      ButtonLoading: false,
    };
  },
  computed: {
    ...mapState({
      info: state => state.user.info,
    }),
  },
  components: {
    [Field.name]: Field,
    [Button.name]: Button,
    [Notify.name]: Notify,
  },
  created() {},
  methods: {
    changePassword() {
      this.ButtonLoading = true;
      const OldPassword = this.password.OldPassword;
      const NewPassword = this.password.NewPassword;
      const AgainPassword = this.password.AgainPassword;
      if (NewPassword === AgainPassword) {
        if (this.info.IsGroupSystem) {
          SetChangePassword({
            OldPassword: md5(OldPassword),
            NewPassword: md5(NewPassword),
          })
            .then(() => {
              Notify({ type: "success", message: "修改成功" });
              this.ButtonLoading = false;
            })
            .catch(() => {
              this.ButtonLoading = false;
            });
        } else {
          SetUserChangePassword({
            OldPassword: md5(OldPassword),
            NewPassword: md5(NewPassword),
          })
            .then(() => {
              Notify({ type: "success", message: "修改成功" });
              this.ButtonLoading = false;
            })
            .catch(err => {
              if (err.message.indexOf("User找不到数据") > -1) {
                Notify({ message: "这不是你所属的门店" });
                this.ButtonLoading = false;
              }
              this.ButtonLoading = false;
            });
        }
      } else {
        Notify({ type: "warning", message: "两次密码输入不一致" });
        this.ButtonLoading = false;
      }
    },
  },
};
</script>
